module.exports = __webpack_public_path__ + "690bc5cc683b85afaaf9db1c180dff15.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/WBU-DSC-card.jpg
// module id = 144
// module chunks = 0